import type { BadgeColor } from '@ksyos/design-system';
import { Badge, Box, Text } from '@ksyos/design-system';

export interface IBadgeWithLabelProps {
    color: BadgeColor;
    label: string;
    value: string;
}

export function BadgeWithLabel({ value, color, label }: IBadgeWithLabelProps) {
    return (
        <Box
            alignItems="center"
            display="flex"
            mr={[0, 6]}
        >
            <Badge
                color={color}
                shape="circle"
                size="large"
                sx={{ mr: [0, 6] }}
                text={value}
            />
            <Text
                color={color === 'inverse' ? 'inverse' : 'minimal'}
                sx={{ display: ['none', 'block'] }}
            >
                {label}
            </Text>
        </Box>
    );
}
